import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { Button } from 'react-bootstrap';
import DevelopDataTable from './DevelopDataTable';
import GenerateTemplate from './GenerateTemplate';
import { ReactComponent as OakSvg } from '../../../../../assets/icons/oak.svg';
import { ReactComponent as PoplarSvg } from '../../../../../assets/icons/poplar.svg';
import { ReactComponent as ChestnutSvg } from '../../../../../assets/icons/chestnut.svg';
import { ReactComponent as SolarSvg } from '../../../../../assets/icons/solar.svg';
import { ReactComponent as WindSvg } from '../../../../../assets/icons/wind.svg';

const Develop = ({ onDrawPolygon }) => {
  const {
    formState: { errors },
    setError,
    clearErrors
  } = useForm();

  return (
    <>
      <GenerateTemplate />

      <Button
        className="m-2"
        onClick={() => onDrawPolygon(1)}
        variant="outline-primary"
      >
        <OakSvg className="land-dev-tree-icon" />
        &nbsp;Oak
      </Button>
      <Button
        className="m-2"
        onClick={() => onDrawPolygon(2)}
        variant="outline-primary"
      >
        <PoplarSvg className="land-dev-tree-icon" />
        &nbsp;Yellow Poplar
      </Button>
      <Button
        className="m-2"
        onClick={() => onDrawPolygon(3)}
        variant="outline-primary"
      >
        <ChestnutSvg className="land-dev-tree-icon" />
        &nbsp;Horse Chestnut
      </Button>
      <Button
        className="m-2"
        onClick={() => onDrawPolygon(4)}
        variant="outline-primary"
      >
        <SolarSvg className="land-dev-tree-icon" />
        &nbsp;Solar Panel
      </Button>
      <Button
        className="m-2"
        onClick={() => onDrawPolygon(5)}
        variant="outline-primary"
      >
        <WindSvg className="land-dev-tree-icon" />
        &nbsp;Wind Turbine
      </Button>

      <DevelopDataTable
        errors={errors}
        setError={setError}
        clearErrors={clearErrors}
      />
    </>
  );
};

Develop.propTypes = {
  onDrawPolygon: PropTypes.func
};
export default Develop;
